import React, { createContext, useContext, useState } from 'react'

import { ApolloError } from '@apollo/client'

import { LoadingWithSpinner } from 'modules/finance/components/FinancialWorkspace/components/LoadingWithSpinner'
import { PlotData } from 'modules/finance/components/FinancialWorkspace/components/Table/types'

import { useEvolutionChartData } from '../../hooks/charts/useEvolutionChartData'
import { useFinancialWorkspace } from '../Provider'

interface Props {
  children: React.ReactNode
}

interface IValue {
  loading: boolean
  error: ApolloError | undefined
  plotData: PlotData[] | undefined
}

const TotalProviderContext = createContext<IValue | undefined>(undefined)

export const TotalProvider: React.FC<Props> = ({ children }) => {
  const { formattedState: variables, insightTableType } = useFinancialWorkspace()

  // Remove conceptIds from variables to avoid fetching data for each concept
  // We only use company cost  concept for payroll chart
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { conceptIds, ...rest } = variables

  const { error, loading, items } = useEvolutionChartData({
    ...rest,
  })

  const plotData = items?.[0]?.data.map((item) => {
    const totalGrossSalaryInCents = Number(item.totalAmountInCents)

    return {
      x: item.label,
      title: item.label,
      y: totalGrossSalaryInCents,
      totalAmountWithPrecision: item.totalAmountWithPrecision,
    }
  })

  if (loading) {
    return <LoadingWithSpinner />
  }

  return (
    <TotalProviderContext.Provider value={{ plotData, loading, error }}>
      {children}
    </TotalProviderContext.Provider>
  )
}

export const useTotal = () => {
  const context = useContext(TotalProviderContext)
  if (context === undefined) {
    throw new Error('useTotal must be used within a TotalProvider')
  }
  return context
}
